export { default } from './RecommendedLeads';
